import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useExpensesFiltersStore } from 'shared/stores/use-expenses-filters.ts';
import { ExpensesSearch } from 'components/expenses/expenses-search';
import { ExpensesFiltersDrawer } from './components/expenses-filters-drawer';

export const ExpensesFilter: React.FC = () => {
  const { t } = useTranslation();
  const { filters, search } = useExpensesFiltersStore();
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Space size='small'>
        <ExpensesSearch />
        <Badge dot={!!filters}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Space>
      <ExpensesFiltersDrawer form={form} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
